import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";

export function AthleticsHamburgerListItems() {
  return (
    <Box>
      <MenuItem
        onClick={() => {
          window.open(
            "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
            "_blank"
          );
        }}
      >
        <ListItemIcon>
          <OpenInNewRoundedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>MLB Privacy Policy</ListItemText>
      </MenuItem>

      <MenuItem
        onClick={() => {
          window.open(
            "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
            "_blank"
          );
        }}
      >
        <ListItemIcon>
          <OpenInNewRoundedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>MLB Terms of Use</ListItemText>
      </MenuItem>
    </Box>
  );
}
